"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectHideSenderImageOption')(function selectShowPreviewTextOption(hideSenderImage, state) {
    var optionState = state.optionState;
    optionState.showSenderImageInListView = hideSenderImage;
}));
//# sourceMappingURL=selectHideSenderImageOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-image-option/lib/actions/selectHideSenderImageOption.js
// module id = 5101
// module chunks = 2